import { render, staticRenderFns } from "./RespondCard.vue?vue&type=template&id=47c40952&scoped=true"
import script from "./RespondCard.vue?vue&type=script&lang=js"
export * from "./RespondCard.vue?vue&type=script&lang=js"
import style0 from "./RespondCard.vue?vue&type=style&index=0&id=47c40952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c40952",
  null
  
)

export default component.exports